// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"53":"webfontloader","594":"about","884":"admin","966":"login"}[chunkId] + "." + {"53":"b22a117c","594":"759777b0","884":"e923decf","966":"84df7618"}[chunkId] + ".js";
};